import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=a5cadcd6&scoped=true"
import script from "./showImage.vue?vue&type=script&lang=js"
export * from "./showImage.vue?vue&type=script&lang=js"
import style0 from "./showImage.vue?vue&type=style&index=0&id=a5cadcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cadcd6",
  null
  
)

export default component.exports